export default "__VITE_ASSET__Cb$fd_MK__"